import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { ECLIPSE_PRIMARY_COLOR, ECLIPSE_CYCLE_DEFAULT_STROKE, ECLIPSE_DISABLED_BORDER_COLOR } from '../../utils/consts';
import { Confirm } from '@wix/wix-ui-icons-common/lazy';
export const CycleSelectorCheck = _ref => {
  let {
    isSelected,
    disabled = false,
    size,
    mobile = false
  } = _ref;
  const resolvedSize = size ?? (mobile ? 18 : 20);
  if (isSelected) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      verticalAlign: "middle",
      align: "center",
      borderRadius: "50%"
    }, mobile ? {
      boxSizing: 'border-box'
    } : {}, {
      width: resolvedSize,
      height: resolvedSize,
      backgroundColor: ECLIPSE_PRIMARY_COLOR
    }), /*#__PURE__*/React.createElement(Confirm, {
      size: resolvedSize - 5,
      color: "white"
    }));
  }
  const borderColor = disabled ? ECLIPSE_DISABLED_BORDER_COLOR : mobile ? ECLIPSE_CYCLE_DEFAULT_STROKE : ECLIPSE_PRIMARY_COLOR;
  return /*#__PURE__*/React.createElement(Box, _extends({
    borderRadius: "50%"
  }, mobile ? {
    boxSizing: 'border-box'
  } : {}, {
    height: resolvedSize,
    width: resolvedSize,
    minWidth: resolvedSize,
    maxWidth: resolvedSize,
    align: "center",
    verticalAlign: "middle",
    border: `1px solid ${borderColor}`
  }));
};
//# sourceMappingURL=CycleSelectorCheck.js.map